export default __webpack_public_path__ + "static/media/kliznekapije1.8f98d8ad.png";